import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IAssetView} from '../schema';

/**
 * `setViewData` request params
 * (what is used to send to server)
 */
//IAssetView is the object get sent alng with a second param that is referencing file so I named it that. **Review**
export type SetViewDataRequestOptions = {
	assetView: IAssetView;
	file?: string | null;
};

/**
 * `setViewData` request
 * (what gets sent to the server)
 */
export type SetViewDataRequest = [
	SetViewDataRequestOptions['assetView'],
	SetViewDataRequestOptions['file'],
];

/**
 * `setViewData` response
 * (what comes back from the server)
 */
export type SetViewDataResponse = SuccessResponse<SetViewDataResult>;

/**
 * `setViewData` result
 * (what is utilized from the server response)
 */
export type SetViewDataResult = string; // uuid

export const setViewDataEndpoint = 'setViewData';

/**
 * Set asset view data
 * @param fetchParams Fetch params
 */
export const setViewData = async ({
	assetView,
	file,
}: SetViewDataRequestOptions) => {
	const client = NetxQueryClient();

	const {viewId, ...rest} = assetView;

	const requestParams: SetViewDataRequest = [
		{
			...rest,
			viewId: viewId || (null as any),
		},
		file ?? null,
	];

	return client
		.post<SetViewDataResponse>(setViewDataEndpoint, requestParams)
		.then(getResponseResults);
};

export default setViewData;
